import React, { useState } from 'react';
import { Carousel, Modal, Button } from 'react-bootstrap';
import "./popoverScroller.css"
import { centerText } from '@yudiel/react-qr-scanner';
const PopoverScoller = ({ show, onHide, carouselEntries , scroll }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            fullscreen
            centered
            dialogClassName="carousel-modal"
            style={{
                top: "var(--nav-height)",
                height: "calc(100% - var(--nav-height))",
                display: "flex",
                // justifyContent: "center",
                // scrollbarGutter: "stable both-edges",
                // paddingLeft: "-1px !important",
                // overflow: "hidden",
                scrollbarWidth: "none",
                // width: "var(--greeting-container-size)"
            }}
            className='popover-scroller-container'
        >
            {scroll ? 
            <div className='scroll-div'>
                {carouselEntries.map((entry, index) => (entry))}
            </div> : <Modal.Body>
                <Carousel>
                    {carouselEntries.map((entry, index) => (
                        <Carousel.Item key={index}>
                            {entry}
                        </Carousel.Item>
                    ))}
                </Carousel>
            </Modal.Body>}
            
        </Modal>
    );
};

export default PopoverScoller;
